import { BaseContainerModel } from '../../base-container.model';
import {
  bl_fi_mst_pricing_scheme_link_RowClass,
} from '../../../dbschema';

export class PricingSchemeLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_pricing_scheme_link: bl_fi_mst_pricing_scheme_link_RowClass = new bl_fi_mst_pricing_scheme_link_RowClass();
}